/*
 * @Author: guozhenqiang 15138913894@163.com
 * @Date: 2023-02-27 10:53:24
 * @LastEditors: guozhenqiang 15138913894@163.com
 * @LastEditTime: 2023-03-08 15:45:50
 * @FilePath: \baichuan-website\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vuex from 'vuex'
import App from './App'
import router from './router'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueI18n from "vue-i18n";
import echarts from 'echarts';
// import animate from 'animate.css';

// Vue.use(animate);
Vue.use(VueI18n);
Vue.prototype.$echarts = echarts

// 定义挂载文件
const i18n = new VueI18n({
  // locale: "zh", // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
  locale: localStorage.getItem('lang') || 'zh',
  messages: {
    zh: require("./lang/language-zh"),
    en: require("./lang/language-en"),
  },
});

if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  Vue.prototype.$pc = false
  //hostConfig.vconsole && new VConsole()
} else {
  Vue.prototype.$pc = true
  let winWidth = document.documentElement.offsetWidth ||
    document.body.offsetWidth
  winWidth = winWidth < 1366 ? 1366 : winWidth
  let oHtml = document.getElementsByTagName('html')[0]
  oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'
  window.addEventListener('resize', function () {
    let winWidth = document.documentElement.offsetWidth || document.body.offsetWidth
    winWidth = winWidth < 1366 ? 1366 : winWidth
    let oHtml = document.getElementsByTagName('html')[0]
    oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'
  })
}


Vue.use(Vuex)
Vue.use(Element);
Vue.config.productionTip = false
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import 'animate.css'
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
router.afterEach(() => {
  window.scrollTo(0, 0);
  NProgress.done()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,// 挂载在全局
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js